import { list } from '../../../../../../common/classes/request-builder';
import {
    InputType,
    DropdownData,
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
} from '@fitogest/reactive-form-builder/interfaces';
import { ProductosModel } from '../../../../../../models/productos/productos.model';

export class ProductosSimpleFormDefinition {
    public formType!: FormType;
    public model: Partial<ProductosModel> = {};
    public formFields!: Form<ProductosModel>;
    public fieldNames: FormField<ProductosModel>[] = [];
    public fieldLabels: string[] = [];

    public udsMedida: DropdownData<string> = list(['...', null], 'Litros', 'Kg');

    constructor(type: FormType, model: Partial<ProductosModel> = {}) {
        this.formType = +type;
        this.model = model;

        this.formFields = {
            name: 'productos-simple',
            header: 'Datos del producto',
            type: this.formType,
            sections: this.getFormSections(),
            table: null,
            uploadButton: {
                isEnabled: false,
                label: '',
            },
            signed: false,
        };
    }

    private getFormSections(): FormSection<ProductosModel>[] {
        return [
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getMainFields(),
                order: 1,
            },
            {
                name: '',
                width: 12,
                isVisible: true,
                fields: this.getHiddenFields(),
                order: 2,
            },
        ];
    }

    private getMainFields(): FormField<ProductosModel>[] {
        const isEditable = this.formType < FormType.DELETION;
        const textInputType = isEditable ? InputType.TEXT : InputType.ONLY_TEXT;
        const dropdownInputType = isEditable ? InputType.DROPDOWN : InputType.ONLY_TEXT;

        const fields: FormField<ProductosModel>[] = [
            {
                name: 'nombre',
                vinculatedFields: undefined,
                label: 'Nombre del producto',
                input: {
                    type: textInputType,
                    isEditable,
                },
                width: 3,
                conditions: this.conditions({ isRequired: true }),
                order: 1,
            },
            {
                name: 'num_registro',
                vinculatedFields: undefined,
                label: 'Nº Registro',
                input: {
                    type: textInputType,
                    isEditable,
                },
                width: 3,
                conditions: this.conditions(),
                order: 2,
            },
            {
                name: 'materia_activa',
                vinculatedFields: undefined,
                label: 'Materia Activa',
                input: {
                    type: textInputType,
                    isEditable,
                },
                width: 3,
                conditions: this.conditions(),
                order: 3,
            },
            {
                name: 'uds_medida',
                vinculatedFields: undefined,
                label: 'Unidades de medida',
                input: {
                    type: dropdownInputType,
                    data: this.udsMedida,
                    isEditable,
                },
                width: 3,
                conditions: this.conditions(),
                order: 4,
            },
        ];

        return this.registerVisibleFields(fields);
    }

    private getHiddenFields(): FormField<ProductosModel>[] {
        return [
            {
                name: 'id',
                vinculatedFields: undefined,
                label: '',
                input: {
                    type: InputType.HIDDEN,
                    isEditable: true,
                },
                width: 0,
                conditions: this.conditions({ isVisible: true }),
                order: 1,
            },
        ];
    }

    private registerVisibleFields(fields: FormField<ProductosModel>[]): FormField<ProductosModel>[] {
        for (const field of fields) {
            if (field.conditions.isVisible) {
                this.fieldNames.push(field);
                this.fieldLabels.push(field.label);
            }
        }

        return fields.sort((a, b) => a.order - b.order);
    }

    private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
        return {
            isRememberedOnDuplicate: false,
            isRequired: false,
            isRetained: false,
            hasUndoEnabled: false,
            isVisible: true,
            ...overrides,
        };
    }
}
